import * as React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"

const AnnouncementBar = () => {
  const data = useStaticQuery(graphql`
    query announcementBarQuery {
      allContentfulWeeklyTheme {
        nodes {
          weeklyThemeTitle
          announcementText
          announcementLink
        }
      }
    }
  `)

  const { announcementLink, announcementText, weeklyThemeTitle } = data.allContentfulWeeklyTheme.nodes[0]

  const isBrowser = typeof window !== "undefined"

  let dismissed = false

  if (isBrowser) {
    dismissed = sessionStorage.getItem('announcementDismissed') || false
  }

  const onClick = e => {sessionStorage.setItem('announcementDismissed', true)}

  return (
    <div className={`announcementBar is-flex is-align-items-center is-justify-content-space-between ${dismissed && "is-hidden" }`}>
      <div className="has-text-centered is-flex-grow-5 p-3">
        <Link to={announcementLink} alt={weeklyThemeTitle} className="has-text-white"> 
          {announcementText}
        </Link>
      </div>
      <div className="is-flex-shrink-0 p-3">
        <button className="button is-small is-ghost" onClick={onClick}><span className="is-size-4 has-text-white">&#215;</span></button>
      </div>
    </div>
  )
}

export default AnnouncementBar